import React from 'react'

import Layout from '../layouts/zh'
import SEO from '../components/seo'
import Sliders from '../components/Sliders'
import Bubble from '../components/Bubble'
import BubbleOutline from '../components/BubbleOutline'
import IntroBox from '../components/IntroBox'
import IllustrationBox from '../components/IllustrationBox'
import Testimonial from '../components/Testimonial'
import FlickitySlider from '../components/FlickitySlider'

const Schools = require('../data/Schools')
const CollegeAchievements = require('../data/CollegeAchievements')

const IndexPage = (props) => (
  <Layout location={props.location}>
    <SEO title="主頁" />

    <Sliders lang="zh" />

    <div className="container py-8">
      <div className="flex flex-row flex-wrap -mx-2 mb-8">
        <div className="box-p65 w-full lg:w-1/3 xl:w-1/2 mb-4">
          <div className="mx-2 absolute inset-0">
            <img src="/AnnualReport2017-2018/images/home/image01.png" alt="IFT" className="object-cover object-bottom h-full w-full" />
          </div>
        </div>

        <div className="w-full lg:w-2/3 xl:w-1/2">
          <Bubble className="mx-2 mb-4"
            title="精銳之師"
            subtitle="成就今日　挑戰未來"
          >
            <div className="text-sm md:text-base leading-relaxed text-justify">
              <p className="mb-4">旅遊學院於1995年成立，是一所澳門特別行政區政府社會文化司的公立高等教育機構，提供一系列旅遊範疇的學位課程和專業培訓，包括酒店、旅遊、文化遺產、會展、零售及市場推廣、休閒娛樂、康體活動、文化創意及廚藝等。</p>
              <p>旅遊學院下設旅遊高等學校和旅遊及酒店業學校，分別提供四年制學士學位課程以及專業培訓課程。</p>
            </div>
          </Bubble>
        </div>
      </div>

      <div className="flex flex-row flex-wrap -mx-2">
        {
          Schools.map((school, i) => (
            <div key={i} className="w-full md:w-1/2 mb-8 flex" data-aos={`${i == 0 ? 'fade-right' : 'fade-left'}`}>
              <IntroBox className="mx-2 text-sm md:text-base h-full"
                title={school.title['zh']}
                more
                link={`/${school.link['zh']}`}
                image={school.image}
              >
                {school.description['zh']}
              </IntroBox>
            </div>
          ))
        }
      </div>
    </div>

    <div className="bg-cover bg-no-repeat bg-cover bg-center pt-8 lg:pt-12 xl:pt-24 mb-12"
      style={{ backgroundImage: "url('/AnnualReport2017-2018/images/home/bg-slogan.jpg')" }}
    >
      <div className="container">
        <div className="flex flex-row -mx-2">
          <BubbleOutline className="w-full md:w-3/4 mx-2 mb-12 text-justify"
            title="院長的話"
            more
            link="/zh/presidents-message"
          >
            <div data-aos="fade-up">
              旅遊學院立足澳門，放眼國際，通過持續提升教學和研究質量，加強學院在國際上的競爭力。致力不斷擴大與全球的教育機構、旅遊組織和研究機構的合作夥伴關係，拓展國際網絡。
            </div>
          </BubbleOutline>

          <div className="hidden md:block self-end w-1/5 md:w-1/4 mx-2">
            <img src="/AnnualReport2017-2018/images/home/principal.png" alt="President" />
          </div>
        </div>
      </div>
    </div>

    <div className="container">
      <h2 className="text-yellow-500 text-3xl text-center mb-12">教學質素備受肯定</h2>

      <div className="flex flex-row flex-wrap -mx-8 md:mb-12">
        {
          CollegeAchievements.illustrationItems.map((item, i) => (
            <div key={i} className="w-1/2 md:w-1/4 mb-12" data-aos="fade-up" data-aos-delay={i * 200}>
              <div className="mx-8">
                <IllustrationBox
                  number={item.number}
                  image={item.image}
                  title={item.title['zh']}
                  text={item.text['zh']}
                  className="text-3xl"
                  alignment="left"
                />
              </div>
            </div>
          ))
        }
      </div>

      <FlickitySlider className="mb-12">
        {
          CollegeAchievements.listItems.map((item, i) => (
            <div key={i} className="w-full md:w-1/2 p-4">
              <Testimonial
                title={item.title['zh']}
                color={item.color}
              >
                {
                  item.content['zh'].map((text, j) => (
                    <p key={j} className="mb-4">
                      { text }
                    </p>
                  ))
                }
              </Testimonial>
            </div>
          ))
        }
      </FlickitySlider>
    </div>
  </Layout>
)

export default IndexPage
